let rebitAccountRoutes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'rebit-accounts', name: 'rebit-accounts.list', component: () => import('./pages/Index.vue') },
      { path: 'rebit-accounts/create', name: 'rebit-accounts.create', component: () => import('./pages/Create.vue') },
      { path: 'rebit-accounts/:id/edit', name: 'rebit-accounts.edit', component: () => import('./pages/Edit.vue') },
      { path: 'rebit-accounts/:id/wallet-addresses/create', name: 'wallet-addresses.create', component: () => import('./pages/wallet_addresses/Create.vue') },
      { path: 'wallet-addresses/:wallet_address_id/edit', name: 'wallet-addresses.edit', component: () => import('./pages/wallet_addresses/Edit.vue') }
    ]
  }
];

export default rebitAccountRoutes;
